<script lang="ts">
  import { page } from "$app/state";

  import type { Snippet } from "svelte";

  interface Props {
    slug: string;
    children: Snippet;
  }
  let { slug, children }: Props = $props();

  let href = $derived(`/llm-almanac/${slug}`);
</script>

<a {href} class="link" class:selected={page.url.pathname.endsWith(slug)}
  >{@render children?.()}</a
>

<style lang="postcss">
  .link {
    @apply text-almanac-dark-green/80 hover:text-almanac-dark-green;
  }
  .link.selected {
    @apply text-almanac-dark-green font-bold;
  }
</style>
